module.exports = __webpack_public_path__ + "img/main.f017d2b1.jpg";